/**
 * The form control names for the Eligibility Criteria form group.
 */
export enum EligibilityCriteriaControlNamesEnum {
  ELIGIBILITY_CRITERIA = 'eligibilityCriteria'
}
